import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	emptyText: {
		id: 'atlassian-navigation.filters.menu.empty.empty-text',
		defaultMessage: 'Search for issues across all projects and save them as filters.',
		description: 'Suggest an action to the user',
	},
	learnMore: {
		id: 'atlassian-navigation.filters.menu.empty.learn-more',
		defaultMessage: 'Learn more',
		description: 'Suggest user click on the link to learn more about apps in jira',
	},
	emptyImg: {
		id: 'atlassian-navigation.filters.menu.empty.empty-img',
		defaultMessage: 'An image showing that the apps dropdown menu is empty',
		description: 'Alt text for empty view',
	},
	emptyTextIssueTermRefresh: {
		id: 'atlassian-navigation.filters.menu.empty.empty-text-issue-term-refresh',
		defaultMessage: 'Search for work items across all projects and save them as filters.',
		description: 'Suggest an action to the user',
	},
});
